import type { AxiosPromise } from 'axios'
import request from '@core/request'

export type dataType = 0 | 1 | 2 // 默认资料、企业资料、产品资料
export type updateFrequency = 0 | 1 | 2 // 不更新、按周更新、按月更新
/**
 * 文件上传
 * @returns {AxiosPromise}
 */
export function fileImport(data: any): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/company/fileImport',
    data,
  })
}
/**
 * 知识库删除
 * @returns {AxiosPromise}
 */
export function knowledgeDel(data: { id: string }): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/company/knowledgeDel',
    data,
  })
}
// 知识库生成
export function knowledgeGen(data: { id: string; materialIds: string[] }): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/company/knowledgeGen',
    data,
  })
}
/**
 * 知识库列表
 * @returns {AxiosPromise}
 */
export function getKnowledgeList(data: any): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/company/knowledgelist',
    data,
  })
}
/**
 * 知识库删除
 * @returns {AxiosPromise}
 */
export function knowledgeMaterialDel(data: unknown): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/company/knowledgeMaterialDel',
    data,
  })
}

/**
 * 知识库素材批量删除
 * @returns {AxiosPromise}
 */
export function knowledgeMaterialBatchDel(data: { ids: (string | number)[] }): AxiosPromise {
  return request({
    method: 'post',
    url: '/company/knowledgeMaterialBatchDel',
    data,
  })
}

/**
 * 知识库素材详情
 * @returns {AxiosPromise}
 */
export function getKnowledgeMaterialDetail(data: { id: string }): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/company/knowledgeMaterialDetail',
    data,
  })
}
/**
 * 知识库详情
 * @returns {AxiosPromise}
 */
export function getKnowledgeDetail(data: { id: string }): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/company/knowledgeDetail',
    data,
  })
}
/**
 * 知识库编辑
 * @returns {AxiosPromise}
 */
export function knowledgeMaterialEdit(data: { id: string; content: string }): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/company/knowledgeMaterialEdit',
    data,
  })
}

/**
 * 知识库资料列表
 * @returns {AxiosPromise}
 */
export function knowledgeMaterialist(data: any): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/company/knowledgeMateriallist',
    data,
  })
}

export function knowledgeTransform(data: any): AxiosPromise {
  return request({
    method: 'post',
    url: '/company/knowledgeTransform',
    data,
  })
}

export function knowledgeRollback(data: any): AxiosPromise {
  return request({
    method: 'post',
    url: '/company/knowledgeRollback',
    data,
  })
}

/**
 * 知识库同步
 * @returns {AxiosPromise}
 */
export function knowledgeSync(data: any): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/company/knowledgeSync',
    data,
  })
}
/**
 * 链接解析
 * @returns {AxiosPromise}
 */
export function linkParse(data: any): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/company/linkParse',
    data,
  })
}
/**
 * 结构化输出内容
 * @returns {AxiosPromise}
 */
export function textExtraction(taskId: string): AxiosPromise {
  return request({
    method: 'get',
    // baseURL: 'http://192.168.26.214:8080',
    url: `/company/textExtraction/${taskId}`,
    data: {},
  })
}
/**
 * 结构化输入内容
 * @returns {AxiosPromise}
 */
export function textInput(taskId: string): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: `/company/textInput/${taskId}`,
    data: {},
  })
}
// 公司结构输出
export function companyTextInput(data: any): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/company/textInput',
    data,
  })
}
/**
 * 整站导入
 * @returns {AxiosPromise}
 */
export function websiteImport(data: unknown): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/company/websiteImport',
    data,
  })
}
/**
 * 任务重启
 * @returns {AxiosPromise}
 */
export function taskRestart(taskId: string): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: `/company/taskRestart/${taskId}`,
    data: {},
  })
}
export function knowledgeGenStreamCheck(data): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: `/company/knowledgeGenStreamCheck`,
    data,
  })
}

/**
 * 知识库关联
 * @returns {AxiosPromise}
 */
export function relateToKnowledge(data: unknown): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/company/relateToKnowledge',
    data,
  })
}
/**
 * 知识库新增
 * @returns {AxiosPromise}
 */
export function knowledgeAdd(data: unknown): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/company/knowledgeAdd',
    data,
  })
}

// AI提示词 - 批量添加
export function keywordAddList(data): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/keyword/addList',
    data,
  })
}

// AI提示词 - 批量删除
export function keywordBatchDelete(data): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/keyword/batchDelete',
    data,
  })
}
// AI提示词 - 生成品牌词
export function generateBrandWords(data): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/keyword/generateBrandWords',
    data,
  })
}
export function batchGenerateBrandWords(data): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/keyword/batchGenerateBrandWords',
    data,
  })
}
// AI提示词 - 生成品牌词
export function generateDistillationWords(data): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/keyword/generateDistillationWords',
    data,
  })
}
export function batchGenerateDistillationWords(data): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/keyword/batchGenerateDistillationWords',
    data,
  })
}
// AI提示词 - 生成场景词
export function generateSceneWords(data): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/keyword/generateSceneWords',
    data,
  })
}
export function batchGenerateSceneWords(data): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/keyword/batchGenerateSceneWords',
    data,
  })
}
// AI提示词 - 语料库明细
export function keywordKnowledgeDetail(data): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/keyword/keywordKnowledgeDetail',
    data,
  })
}
// AI提示词 - 列表
export function getKeywordList(data): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/keyword/list',
    data,
  })
}
// AI提示词 - 模糊搜索
export function keywordSearch(data): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/keyword/search',
    data: {
      ...data,
      pageSize: Math.min(data.pageSize ?? 200, 200),
    },
  })
}

// 指令库 - 批量删除
export function accountGeoArticlePromptBatchDelete(data): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/accountGeoArticlePrompt/batchDelete',
    data,
  })
}
// 指令库 - 新建指令生成任务
export function accountGeoArticlePromptCreateTask(data): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/accountGeoArticlePrompt/createTask',
    data,
  })
}
// 指令库 - 任务指令失败重试
export function accountGeoArticlePromptRetryTask(data): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/accountGeoArticlePrompt/retryTask',
    data,
  })
}
// 指令库 - 指令修改
export function accountGeoArticlePromptEdit(data): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/accountGeoArticlePrompt/edit',
    data,
  })
}
// 指令库 - 生成指令
export function accountGeoArticlePromptGenerationInstruction(data): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/accountGeoArticlePrompt/generationInstruction',
    data,
  })
}
// 指令库 - 查询指令任务详情
export function accountGeoArticlePromptGetTaskDetail(data): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/accountGeoArticlePrompt/getTaskDetail',
    data,
  })
}
// 指令库 - 查询指令列表
export function accountGeoArticlePromptList(data): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/accountGeoArticlePrompt/list',
    data,
  })
}
// 指令库 - 查询指令默认列表
export function accountGeoArticlePromptDefaultlist(data): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/accountGeoArticlePrompt/defaultlist',
    data,
  })
}
// 指令库 - 批量删除指令任务
export function accountGeoArticlePromptTaskBatchDelete(data): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/accountGeoArticlePrompt/taskBatchDelete',
    data,
  })
}
// 指令库 - 查询指令任务列表
export function accountGeoArticlePromptTaskList(data): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/accountGeoArticlePrompt/taskList',
    data,
  })
}
// 指令库 - 查询指令任务列表
export function accountGeoArticlePromptTaskStatusByIds(data): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/accountGeoArticlePrompt/taskStatusByIds',
    data,
  })
}

// 添加任务
export function articleListAddTask(data): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/article/addtask',
    data,
  })
}
// 文章生成
export function articleListGen(data): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/article/gen',
    data,
  })
}
// 文章生成
export function getArticleStatus(data): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/article/getArticleStatus',
    data,
  })
}
// 获取详情
export function articleListGetDetail(data): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/article/getDetail',
    data,
  })
}
// 文章列表
export function getArticleList(data): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/article/list',
    data,
  })
}
// 批量重新检测文章违禁词
export function batchCheckBannedWords(data) {
  return request({
    method: 'post',
    url: '/article/batchCheckBannedWords',
    data,
  })
}
// 发布官媒
export function articlePubOfficeMedia(data): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/article/pubOfficeMedia',
    data,
  })
}
// 生成任务列表
export function articleTasklist(data): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/article/tasklist',
    data,
  })
}
// 编辑AI生成的文章内容
export function articleUpdateContent(data): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/article/updateContent',
    data,
    errorMessageShow: false,
  })
}
// 公司知识库 - 输入文档
export function corpusInput(data): AxiosPromise {
  return request({
    method: 'post',
    // baseURL: 'http://192.168.26.214:8080',
    url: '/company/corpusInput',
    data,
  })
}

export function qcLanguagelist(): AxiosPromise {
  return request({
    method: 'get',
    url: '/article/qcLanguagelist',
  })
}

export function qcLocalelist(): AxiosPromise {
  return request({
    method: 'get',
    url: '/article/qcLocalelist',
  })
}

export function addQcArticleTask(data: unknown): AxiosPromise {
  return request({
    method: 'post',
    url: '/article/addQcArticleTask',
    data,
  })
}

export function articleGenTDK(data: unknown): AxiosPromise {
  return request({
    method: 'post',
    url: '/article/gentdk',
    data,
  })
}

/**
 * 下载蒸馏词导入模板
 * @returns {AxiosPromise}
 */
export function downloadDistillationTemplate(): AxiosPromise {
  return request({
    method: 'get',
    url: '/keyword/downloadDistillationTemplate',
    responseType: 'blob',
  })
}

/**
 * 下载品牌词导入模板
 * @returns {AxiosPromise}
 */
export function downloadBrandTemplate(): AxiosPromise {
  return request({
    method: 'get',
    url: '/keyword/downloadBrandTemplate',
    responseType: 'blob',
  })
}

/**
 * 下载场景词导入模板
 * @returns {AxiosPromise}
 */
export function downloadSceneTemplate(): AxiosPromise {
  return request({
    method: 'get',
    url: '/keyword/downloadSceneTemplate',
    responseType: 'blob',
  })
}

/**
 * 蒸馏词批量导入
 * @returns {AxiosPromise}
 */
export function importDistillationWords(data: FormData): AxiosPromise {
  return request({
    method: 'post',
    url: '/keyword/importDistillationWords',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

/**
 * 品牌词批量导入
 * @returns {AxiosPromise}
 */
export function importBrandWords(data: FormData): AxiosPromise {
  return request({
    method: 'post',
    url: '/keyword/importBrandWords',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

/**
 * 场景词批量导入
 * @returns {AxiosPromise}
 */
export function importSceneWords(data: FormData): AxiosPromise {
  return request({
    method: 'post',
    url: '/keyword/importSceneWords',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

// 行业洞察 - 信源排行榜
export function sourceRanking(data): AxiosPromise {
  return request({
    method: 'post',
    url: '/keywordSearchParesResult/sourceRanking',
    data,
  })
}

// 行业洞察 - 信源洞察查询
export function sourceInsight(data): AxiosPromise {
  return request({
    method: 'post',
    url: '/keywordSearchParesResult/sourceInsight',
    data,
  })
}

// 行业洞察 - 行业洞察查询
export function industryInsight(data): AxiosPromise {
  return request({
    method: 'post',
    url: '/keywordSearchParesResult/industryInsight',
    data,
  })
}

// 行业洞察 - 行业列表查询
export function industryList(): AxiosPromise {
  return request({
    method: 'get',
    url: '/keywordSearchParesResult/industryList',
  })
}
